"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const dates_1 = require("../../type-checking/dates");
const get_value_1 = require("./get-value");
const get_value_2 = require("../date-field/get-value");
class DateRangeFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, dates_1.isDateRangeValue)(fieldValue);
        };
        this.getEmptyValue = () => (0, get_value_1.getDateRangeFieldEmptyValue)();
        this.isOptimizedFieldValue = (fieldValue) => (0, dates_1.isOptimizedDateRangeValue)(fieldValue);
        this.getValueFromOptimized = (fieldValue) => {
            if ((0, dates_1.isDateAsStringValue)(fieldValue)) {
                return {
                    from_date: (0, get_value_2.getDateValueFromOptimized)(fieldValue),
                    to_date: (0, get_value_2.getDateValueFromOptimized)(fieldValue),
                };
            }
            return {
                from_date: (0, get_value_2.getDateValueFromOptimized)(fieldValue.from_date),
                to_date: (0, get_value_2.getDateValueFromOptimized)(fieldValue.to_date),
            };
        };
    }
}
exports.DateRangeFieldValueGetter = DateRangeFieldValueGetter;
